import { SettingsForm } from '../features/settings';

function Setting(props: any) {
    return <SettingsForm {...props} />;
}

export default Setting;
